import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import DownloadIcon from "@mui/icons-material/Download";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import ShareIcon from "@mui/icons-material/Share";
import DescriptionIcon from "@mui/icons-material/Description";
import LockIcon from "@mui/icons-material/Lock";
import PaidIcon from "@mui/icons-material/Paid";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import PrintIcon from "@mui/icons-material/Print";
import { IoMdArrowDropright } from "react-icons/io";
import { useGlobalContext } from "../../../Context/GlobalContext";
import ClipLoader from "react-spinners/ClipLoader";
import PayrollFinalizedSidebar from "../../../components/Staff/Modals/PayrollFinalizedSidebar";
import PayrollCtcSidebar from "../../../components/Staff/Modals/PayrollCtcSidebar";
import PayrollSavePayment from "../../../components/Staff/Modals/PayrollSavePayment";
import Cookies from "js-cookie";
import AddIcon from "@mui/icons-material/Add";
import RunPayrollPaidModel from "../../../components/Staff/Modals/RunPayrollPaidModel";
import { usePayrollContext } from "../../../Context/PayrollContext";
import StaffSelectedRunPayrollModel from "../../../components/Staff/Modals/StaffSelectedRunPayrollModel";
import { saveAs } from "file-saver";


const RunPayroll = ({ toggleRunTab }) => {
  let subtitle;
  const {
    staffs,
    fetchStaffs,
    isLoading,
    baseUrl,
    openToast,
    setSelectedStaff,
    savePaymentData,
    setSavePaymentData,
    resetState
  } = useGlobalContext();
  const dropdownRef = useRef(null);
  const { selectAllInput, setSelectAllInput, loading, setMonthYear, month, year, payrollDetail, fetchPayrollDetails, handleMonthChange } = usePayrollContext();
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isOffCanvasOpenCtc, setIsOffCanvasOpenCtc] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [defaultMonth, setDefaultMonth] = useState("");
  const [isOffCanvasOpenPaid, setIsOffCanvasOpenPaid] = useState(false);
  const [isOffCanvasOpenAction, setIsOffCanvasOpenAction] = useState(false);
  const [paidPaymentPrice, setPaidPaymentPrice] = useState("");
  const [selectedPayroll, setSelectedPayroll] = useState(null);
  const navigate = useNavigate();



  const [toggleDrop11, setToggleDrop11] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    console.log(toggleRunTab);
  }, [toggleRunTab]);

  function handledrop11() {
    setToggleDrop11(!toggleDrop11);
  }
  const toggleOffCanvasPaid = () => {
    setIsOffCanvasOpenPaid(!isOffCanvasOpenPaid);
  };

  const toggleOffCanvasAction = () => {
    setIsOffCanvasOpenAction(!isOffCanvasOpenAction);
  };

  const [toggleDrop37, setToggleDrop37] = useState(false);

  function handledrop37() {
    setToggleDrop37(!toggleDrop37);
  }

  function getDayIndex(day) {
    const days = ["One", "Two", "Three", "Four", "Five"];
    return days[day];
  }

  const [toggleDrop38, setToggleDrop38] = useState(false);

  function handledrop38() {
    setToggleDrop38(!toggleDrop38);
  }

  const [modalIsOpen9, setIsOpen9] = React.useState(false);
  function openModal9() {
    setIsOpen9(true);
  }
  function afterOpenModal9() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal9() {
    setIsOpen9(false);
  }

  const [modalIsOpen10, setIsOpen10] = React.useState(false);
  function openModal10() {
    setIsOpen10(true);
  }
  function afterOpenModal10() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal10() {
    setIsOpen10(false);
  }

  const [modalIsOpen12, setIsOpen12] = React.useState(false);
  function openModal12() {
    setIsOpen12(true);
  }
  function afterOpenModal12() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal12() {
    setIsOpen12(false);
  }

  const [modalIsOpenPaySlip, setIsOpenPaySlip] = React.useState(false);
  function openModalPaySlip() {
    setIsOpenPaySlip(true);
  }
  function afterOpenModalPaySlip() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModalPaySlip() {
    setIsOpenPaySlip(false);
  }


  const [modalIsOpen13, setIsOpen13] = React.useState(false);
  const [modalIsOpen15, setIsOpen15] = React.useState(false);

  function openModal13() {
    setIsOpen13(true);
  }
  function afterOpenModal13() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal13() {
    setIsOpen13(false);
  }

  const [modalIsOpen14, setIsOpen14] = React.useState(false);
  function openModal14() {
    setIsOpen14(true);
  }
  function afterOpenModal14() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal14() {
    setIsOpen14(false);
  }

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleDrop = (dropdown) => {
    setActiveDropdown((prev) => (prev === dropdown ? null : dropdown));
  };

  const handleClickOutside = (event) => {
    handleClickOutside2(event);
    if (!event.target.closest(".dropdown-container")) {
      setActiveDropdown(null);
    }
  };

  const handleClickOutside2 = (event) => {
    if (!event.target.closest(".pay-slip2")) {
      setToggleDrop37(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggleDrop38(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleOffCanvas = () => {
    setIsOffCanvasOpen(!isOffCanvasOpen);
  };

  const toggleOffCanvasCtc = () => {
    setIsOffCanvasOpenCtc(!isOffCanvasOpenCtc);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectAllInput(payrollDetail);
    } else {
      setSelectAllInput([]);
    }
  };

  const handleIndividualSelect = (e, staff) => {

    if (e.target.checked) {
      // Add the staff object to the state when the checkbox is checked
      setSelectAllInput((prev) => [...prev, staff]);
    } else {
      // Remove the staff object when unchecked
      setSelectAllInput((prev) =>
        prev.filter((selected) => selected.id !== staff.id)
      );
    }
  };



  useEffect(() => {
    setMonthYear(`${year}-${month}`);
  }, [year, month]);

  const handleProceed = () => {
    if (selectAllInput?.length === 0) {
      openModal13();
    } else {
      setIsOpen15(true);
    }
  };

  const calculateDailySalary = (monthlySalary, workingDaysInMonth = 30) => {
    if (monthlySalary && monthlySalary > 0) {
      return (monthlySalary / workingDaysInMonth).toFixed(2); // Divide by the number of working days in a month
    } else {
      return 0; // Return 0 if monthlySalary is invalid
    }
  };

  function calculateTotalFineAndOvertime(punchRecords) {
    let totalFine = 0;
    let totalOvertime = 0;

    punchRecords?.forEach((record) => {
      // Handle Fine Calculation
      if (record.fine) {
        const {
          totalAmount = 0,
          excessBreakAmount = 0,
          lateEntryAmount = 0,
          earlyOutAmount = 0,
        } = record.fine;

        totalFine += totalAmount > 0
          ? totalAmount
          : excessBreakAmount + lateEntryAmount + earlyOutAmount;
      }

      // Handle Overtime Calculation
      if (record.Overtime) {
        const {
          totalAmount = 0,
          lateOutOvertimeAmount = 0,
          earlyCommingEntryAmount = 0,
        } = record.Overtime;

        totalOvertime += totalAmount > 0
          ? totalAmount
          : lateOutOvertimeAmount + earlyCommingEntryAmount;
      }
    });

    return { totalFine: parseFloat(totalFine).toFixed(2), totalOvertime: parseFloat(totalOvertime).toFixed(2) };
  }




  return (
    <>
      <PayrollFinalizedSidebar
        offCanvas={toggleOffCanvas}
        isOffCanvasOpen={isOffCanvasOpen}
        setIsOffCanvasOpen={toggleOffCanvas}
        data={selectedPayroll}
        fetchPayrollDetails={fetchPayrollDetails}
        selectedPayroll={selectedPayroll}
      />
      <PayrollCtcSidebar
        isOffCanvasOpenCtc={isOffCanvasOpenCtc}
        setIsOffCanvasOpenCtc={toggleOffCanvasCtc}
        toggleOffCanvasCtc={toggleOffCanvasCtc}
      />
      <PayrollSavePayment
        isOffCanvasOpenCtc={modalIsOpen15}
        setIsOffCanvasOpenCtc={() => {
          setIsOpen15(false);
          setSelectAllInput([]);
        }}
        data={selectAllInput}
        toggleOffCanvasCtc={toggleOffCanvasCtc}
        fetchPayrollDetails={fetchPayrollDetails}
      />
      <StaffSelectedRunPayrollModel
        openModal={modalIsOpenPaySlip}
        afterOpenModal={afterOpenModalPaySlip}
        closeModal={closeModalPaySlip}
        message={"Please Select Staff to Download Pay Slip"}

      />
      <RunPayrollPaidModel
        offCanvas={toggleOffCanvasPaid}
        isOffCanvasOpen={isOffCanvasOpenPaid}
        setIsOffCanvasOpen={toggleOffCanvasPaid}
        paidPayment={paidPaymentPrice}
        setPaidPayment={setPaidPaymentPrice}
      />

      <div className="mt-[20px] w-[100%]">
        <div className="flex mt-[20px]">
          <div className="w-full">
            <div className="flex lg:flex-row xl:flex-row flex-col justify-between gap-[20px] w-full">
              <div className="flex md:flex-row flex-col gap-[20px]">
                <button
                  className="flex items-center gap-[8px] bg-[#f4f5f9] lg:bg-[#fff] xl:bg-[#fff] p-[9px] lg:p-[0] xl:p-[0] rounded-[9px] font-normal text-[14px] whitespace-nowrap"
                  onClick={openModal10}
                >
                  <DescriptionIcon className="sheet-icon" />
                  Salary Sheet
                </button>

                <button
                  className="flex items-center gap-[8px] bg-[#f4f5f9] lg:bg-[#fff] xl:bg-[#fff] p-[9px] lg:p-[0] xl:p-[0] rounded-[9px] font-normal text-[14px] whitespace-nowrap"
                  onClick={() => {
                    if (selectAllInput?.length === 0) {
                      openModal12();
                    } else {
                      navigate("/verify-attendance");
                    }
                  }}
                >
                  <LockIcon className="sheet-icon" />
                  Finalize Payroll
                </button>

                <button
                  className="flex items-center gap-[8px] bg-[#f4f5f9] lg:bg-[#fff] xl:bg-[#fff] p-[9px] lg:p-[0] xl:p-[0] rounded-[9px] font-normal text-[14px] whitespace-nowrap"
                  onClick={() => {
                    handleProceed();
                  }}
                >
                  <PaidIcon className="sheet-icon" />
                  Save Payment
                </button>

                <button
                  className="flex items-center gap-[8px] bg-[#f4f5f9] lg:bg-[#fff] xl:bg-[#fff] p-[9px] lg:p-[0] xl:p-[0] rounded-[9px] font-normal text-[14px] whitespace-nowrap"
                  onClick={openModal14}
                >
                  <CreditScoreIcon className="sheet-icon" />
                  Pay Online
                </button>

                <div className="relative flex" ref={dropdownRef}>
                  <button
                    className="flex items-center gap-[8px] bg-[#f4f5f9] lg:bg-[#fff] xl:bg-[#fff] p-[9px] lg:p-[0] xl:p-[0] rounded-[9px] w-full font-normal text-[14px] whitespace-nowrap"
                    onClick={handledrop38}
                  >
                    <PrintIcon className="sheet-icon" />
                    Pay Slips
                  </button>
                  {toggleDrop38 && (
                    <div
                      className="right-0 left-[4px] md:left-[-100px] lg:left-[-100px] xl:left-[-270px] z-10 absolute bg-white ring-opacity-5 set-shadow mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-[98%] md:w-[200px] lg:w-[200px] xl:w-[300px] origin-top-right focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1"
                    >
                      <div className="py-1" role="none">
                        <button
                          className="flex items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="menu-item-1"
                          onClick={() => {
                            if (selectAllInput?.length === 0) {
                              openModalPaySlip();
                            } else {
                              // exportToCSV();
                            }
                          }}
                        >
                          <DownloadIcon className="font-normal text-[#27004a] text-[18px]" />{" "}
                          Download Pay Slip
                        </button>
                        <button
                          className="flex items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="menu-item-0"
                        >
                          <ShareIcon className="font-normal text-[#27004a] text-[18px]" />{" "}
                          Share Pay Slip
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="relative flex justify-end">
                  <button
                    className="bg-[#e5e7eb] px-[7px] py-[8px] rounded-md font-normal text-[#000] text-[16px] pay-slip2"
                    onClick={handledrop37}
                  >
                    <MoreVertIcon />
                  </button>
                  {toggleDrop37 && (
                    <div
                      className="top-[40px] right-0 left-[4px] md:left-[-100px] lg:left-[-100px] xl:left-[-270px] z-10 absolute bg-white ring-opacity-5 set-shadow mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-[98%] md:w-[200px] lg:w-[200px] xl:w-[300px] origin-top-right focus:outline-none payroll-sheet"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1"
                    >
                      <div className="py-1" role="none">
                        <NavLink
                          to="/calender"
                          className="flex items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="menu-item-1"
                        >
                          <UploadFileIcon className="font-normal text-[#27004a] text-[18px]" />{" "}
                          Import Earnings
                        </NavLink>
                        <NavLink
                          to="/day-wise"
                          className="flex items-center gap-[10px] hover:bg-[#e3e3e3] px-4 py-2 text-gray-700 text-sm"
                          role="menuitem"
                          tabindex="-1"
                          id="menu-item-0"
                        >
                          <UploadFileIcon className="font-normal text-[#27004a] text-[18px]" />{" "}
                          Import Deductions
                        </NavLink>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="w-full md:w-auto md:text-end">
                {/* <button className='justify-center w-full md:w-auto second-btn'>Reset</button> */}
              </div>
            </div>
          </div>
        </div>



        <div className="flex lg:flex-row xl:flex-row flex-col justify-between items-start lg:items-center xl:items-center gap-[10px] mt-[20px] mb-4">
          <div className="relative summary-border rounded-[10px] w-full lg:w-[240px] xl:w-[240px]">
            <input
              type="text"
              placeholder="Search"
              className="px-[10px] py-[9px] pr-[26px] pl-[10px] rounded-[10px] text-[13px] client-add focus-visible:outline-none"
            />
            <SearchIcon className="top-[12px] right-[6px] absolute text-gray-500 newadd2" />
          </div>

          <div className="">
            <input
              type="month"
              onChange={handleMonthChange}
              className="p-[8px] border rounded-md w-[100%] lg:w-[240px] font-normal text-[14px] focus-visible:outline-none"
              value={`${year}-${month}`}
            />
          </div>
        </div>

        <div className="mt-5">
          {/* <div className="mt-5"> */}

          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-[100%] h-[100%] overflow-x-auto">
            <table className="border-[#dcdbdb] border-collapse border rounded-lg w-full overflow-hidden table-auto">
              <thead className="border-gray-300 shadow-md border cursor-pointer">
                <th className="flex justify-center p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={
                      selectAllInput?.length === staffs?.length &&
                      staffs?.length > 0
                    }
                  />
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Name
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("name")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "name" && (
                        <div
                          className="left-[-200px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Job Title
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("jobTitle")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "jobTitle" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Payroll Finalized
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("payroll")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "payroll" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>
                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    CTC
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("ctc")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "ctc" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Payables
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("payables")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "payables" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Total Salary
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("totalsalary")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "totalsalary" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Paid
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("paid")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "paid" && (
                        <div
                          className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                  <div className="flex justify-center">
                    Pending
                    <div className="relative dropdown-container">
                      <button onClick={() => handleDrop("pending")}>
                        <FilterListIcon className="filter-icon" />
                      </button>

                      {activeDropdown === "pending" && (
                        <div
                          className="left-[-200px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="menu-button"
                          tabIndex="-1"
                        >
                          <div className="py-1" role="none">
                            <Link
                              to="/add-one-staff"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-0"
                            >
                              Sort A to Z
                            </Link>
                            <Link
                              to="#"
                              className="block px-4 py-2 text-gray-700 text-sm"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-1"
                            >
                              Sort Z to A
                            </Link>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </th>

                {toggleDrop11 && (
                  <>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Total Earnings
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("total-earning")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "total-earning" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>

                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Basic Salary
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("basic-salary")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "basic-salary" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>

                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Work Basis Payment
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("work-base")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "work-base" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>

                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Incentives
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("incentives")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "incentives" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Reimbrusments
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Reimbrusments")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Reimbrusments" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Bonus
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Bonus")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Bonus" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Overtime Pay
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Overtime")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Overtime" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Other Earnings
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Earnings")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Earnings" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Employee PF
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Employee")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Employee" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Employee ESI
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("EmployeeESI")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "EmployeeESI" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        PF EDLI & Admin Charges
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("edli")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "edli" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Employee LWF
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("em-lwf")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "em-lwf" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Professional Tax
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("professional")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "professional" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Late Fine
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("latefine")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "latefine" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Early Fine
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("earlyfine")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "earlyfine" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Other Deductions
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("Deductions")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "Deductions" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Loan Payment
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("loan")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "loan" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                    <th className="p-[10px] border-r font-medium text-center text-xs whitespace-nowrap">
                      <div className="flex">
                        Pending
                        <div className="relative dropdown-container">
                          <button onClick={() => handleDrop("pending")}>
                            <FilterListIcon className="filter-icon" />
                          </button>

                          {activeDropdown === "pending" && (
                            <div
                              className="left-[0px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md divide-y divide-gray-100 ring-1 ring-black w-56 text-left origin-top-right focus:outline-none"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="menu-button"
                              tabIndex="-1"
                            >
                              <div className="py-1" role="none">
                                <Link
                                  to="/add-one-staff"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-0"
                                >
                                  Sort A to Z
                                </Link>
                                <Link
                                  to="#"
                                  className="block px-4 py-2 text-gray-700 text-sm"
                                  role="menuitem"
                                  tabIndex="-1"
                                  id="menu-item-1"
                                >
                                  Sort Z to A
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </th>
                  </>
                )}
              </thead>
              <tbody>
                {loading && (
                  <tr className="h-[100px]">
                    <td
                      colSpan="9"
                      className="border-[#dbdbdb] py-4 font-semibold text-center text-gray-600 text-xl whitespace-nowrap"
                    >
                      <ClipLoader color="#24007a" size={50} />
                    </td>
                  </tr>
                )}
                {!loading &&
                  payrollDetail &&
                  payrollDetail?.map((staff) => {
                    let formattedTotal = 0;
                    let formattedPending = 0;
                    let pending = 0;
                    let totalEarnings = 0;
                    let paid = 0;
                    const punchRecords =
                      staff?.staffDetails?.PunchRecords || [];
                    const salaryDetails =
                      staff?.staffDetails?.SalaryDetails[0] || {};
                    const paymentHistory = salaryDetails.PaymentHistory || [];
                    let totalReimbursement = salaryDetails?.Reimbursement?.reduce((acc, curr) => acc + curr.amount, 0);
                    let totalIncentive = salaryDetails?.Incentive?.reduce((acc, curr) => acc + curr.amount, 0);

                    // Calculate payables
                    const presentCount = punchRecords.filter(
                      (punch) => punch?.status === "PRESENT"
                    )?.length;
                    const halfDayCount = punchRecords.filter(
                      (punch) => punch?.status === "HALFDAY"
                    )?.length;
                    const paidLeaveCount = punchRecords.filter(
                      (punch) => punch?.status === "PAIDLEAVE"
                    )?.length;
                    let totalWeekOffs = punchRecords?.filter(
                      (punch) => {
                        const date = new Date(punch?.punchDate);
                        return date.getDay() === 0;
                      }
                    ).length;

                    const payables =
                      presentCount + halfDayCount * 0.5 + paidLeaveCount + totalWeekOffs;
                    if (staff?.staffDetails?.SalaryDetails[0]) {
                      const { totalFine, totalOvertime } = calculateTotalFineAndOvertime(staff.punchRecords);
                      paid =
                        paymentHistory?.length > 0
                          ? paymentHistory.reduce(
                            (total, payment) =>
                              total + (payment?.amount || 0),
                            0
                          )
                          : 0;

                      const dailySalary = calculateDailySalary(
                        salaryDetails?.ctc_amount || 0
                      );
                      totalEarnings =
                        payables * dailySalary + totalReimbursement + totalIncentive;
                      pending = totalEarnings - paid;
                      formattedTotal =
                        parseFloat(totalEarnings).toFixed(2) != NaN
                          ? parseFloat(totalEarnings).toFixed(2)
                          : 0;
                      formattedPending =
                        parseFloat(pending).toFixed(2) != NaN ? parseFloat(formattedTotal - paid).toFixed(2) : 0;
                    }
                    return (
                      <tr key={staff?.id} className="border">
                        <td
                          className={`p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden ${staff?.staffDetails?.SalaryDetails[0]
                            ? ""
                            : ""
                            }`}
                        >
                          <input
                            type="checkbox"
                            className={`border-1 border  rounded-md  ${staff?.staffDetails?.SalaryDetails[0]
                              ? ""
                              : "opacity-[0.2] cursor-not-allowed"
                              }`}
                            onChange={(e) =>
                              handleIndividualSelect(e, {
                                ...staff,
                                pending: formattedPending,
                                total: formattedTotal,
                              })
                            } // Pass the staff object
                            checked={selectAllInput?.some(
                              (s) => s.id === staff.id
                            )}
                            disabled={
                              !staff?.staffDetails?.SalaryDetails[0]?.ctc_amount
                            }
                          />
                        </td>
                        <td className="p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                          <Link
                            onClick={() => setSelectedStaff(staff)}
                            to={`/personal-detail/${staff?.id}`}
                            className="font-medium text-[#8A25B0] cursor-pointer"
                          >
                            {staff?.name || "N/A"}
                          </Link>
                        </td>
                        <td className="p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                          {staff?.staffDetails?.job_title || "N/A"}
                        </td>

                        {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount ? (
                          <>
                            <td className="p-[10px] border-r max-w-[121px] font-normal text-[#24007a] text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                              <button
                                onClick={() => {
                                  setSelectedPayroll({
                                    ...staff,
                                    pending: formattedPending,
                                    total: formattedTotal,
                                  });
                                  setIsOffCanvasOpen(true);
                                }}
                              >
                                {staff?.staffDetails?.SalaryDetails[0]
                                  ?.payroll_finalized
                                  ? "Yes"
                                  : "No"}
                              </button>
                            </td>
                            <td
                              onClick={() => setIsOffCanvasOpenCtc(true)}
                              className="p-[10px] border-r max-w-[121px] font-normal text-[#24007a] text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden"
                            >
                              {staff?.staffDetails?.SalaryDetails[0]?.ctc_amount}
                            </td>
                            <td className="p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                              {payables}
                            </td>
                            <td className="p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                              ₹{formattedTotal}
                            </td>
                            <td className="p-[10px] border-r max-w-[121px] font-normal text-[#24007a] text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                              <button
                                onClick={() => {
                                  setIsOffCanvasOpenPaid(true);
                                  setPaidPaymentPrice(staff);
                                }}
                              >
                                ₹{paid}
                              </button>
                            </td>
                            <td className="p-[10px] border-r max-w-[121px] font-normal text-center text-ellipsis text-xs whitespace-nowrap overflow-hidden">
                              ₹{formattedPending}
                            </td>
                          </>
                        )
                          : (
                            // Show a single column if ctc_amount is not available
                            <td
                              className="border-[#dbdbdb] p-[10px] text-center text-xs whitespace-nowrap"
                              colSpan="6" // Span across all columns
                            >
                              Please <Link to={`/salary-details-edit/${staff?.id}`} onClick={() => { setSelectedStaff(staff) }} className="font-medium text-[#24007a]">add ctc</Link> to see Payroll
                            </td>
                          )}

                      </tr>
                    );
                  })}

                {
                  !loading && payrollDetail?.length == 0 && (
                    <tr className="h-[100px]">
                      <td
                        colSpan="9"
                        className="border-[#dbdbdb] py-4 text-[14px] text-black text-center whitespace-nowrap"
                      >
                        No Data Found
                      </td>
                    </tr>
                  )
                }

              </tbody>
            </table>
          </div>
          <div className="mb-0 w-full">
            <h2 className="pt-[10px] pb-[10px] pl-2 text-left whitespace-nowrap">
              Grand Total
            </h2>
          </div>
          {/* </div> */}
        </div>

        <Modal
          classNames={{
            modal:
              "max-h-[90vh] overflow-y-auto p-4 w-[90%] max-w-[600px] custom-scrollbar",
          }}
          isOpen={modalIsOpen9}
          onAfterOpen={afterOpenModal9}
          onRequestClose={closeModal9}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
          >
            Apply Filters
          </h2>
          <button
            onClick={closeModal9}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[10px] pb-2">
            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Payroll Month
              </label>
              <br />
              <input
                type="date"
                className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Salary Type
              </label>
              <br />
              <select className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none">
                <option>All Branches</option>
                <option>Demo Main Branchs</option>
              </select>
            </div>
            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Company Branches
              </label>
              <br />
              <select className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none">
                <option>All Branches</option>
                <option>Demo Main Branchs</option>
              </select>
            </div>

            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Departments
              </label>
              <br />
              <select className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none">
                <option>All Departments</option>
                <option>Website</option>
              </select>
            </div>
            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Date of Joining
              </label>
              <br />
              <input
                type="date"
                className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none"
              />
            </div>
            <div className="mb-2">
              <label htmlFor="" className="font-medium text-[14px]">
                Date of Living
              </label>
              <br />
              <input
                type="date"
                className="p-[8px] border rounded-md w-[100%] text-sm focus-visible:outline-none"
              />
            </div>
            <div className="flex items-end mb-2">
              <div className="flex items-center gap-[10px]">
                <input
                  type="checkbox"
                  id="incentive"
                  name="incentive"
                  value="incentive"
                />
                <label for="incentive"> Show Incentive Staff</label>
              </div>
            </div>

            <div className="flex justify-end gap-[10px] p-2 border-t">
              {/* <button className="first-btn" onClick={closeModal9}>
                Reset
              </button> */}
              <button className="second-btn">Apply</button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen10}
          onAfterOpen={afterOpenModal10}
          onRequestClose={closeModal10}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
          >
            No Staff Selected
          </h2>
          <button
            onClick={closeModal10}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[10px] pb-2">
            <div className="pt-[30px] pb-[30px] text-center">
              <WarningIcon className="text-red-600 transition warning-icon" />
              <p className="mt-3">
                Please select staff to download salary sheet.
              </p>
            </div>

            <div className="flex justify-end gap-[10px] p-2 border-t">
              <button className="second-btn">Okay</button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen12}
          onAfterOpen={afterOpenModal12}
          onRequestClose={closeModal12}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
          >
            No Staff Selected
          </h2>
          <button
            onClick={closeModal12}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[10px] pb-2">
            <div className="pt-[30px] pb-[30px] text-center">
              <WarningIcon className="text-red-600 transition warning-icon" />
              <p className="mt-3">Please select staff to Finalize Payroll</p>
            </div>

            <div className="flex justify-end gap-[10px] p-2 border-t">
              <button className="second-btn" onClick={closeModal12}
              >Okay</button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen13}
          onAfterOpen={afterOpenModal13}
          onRequestClose={closeModal13}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
          >
            No Staff Selected
          </h2>
          <button
            onClick={closeModal13}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[10px] pb-2">
            <div className="pt-[30px] pb-[30px] text-center">
              <WarningIcon className="text-red-600 transition warning-icon" />
              <p className="mt-3">
                Please select staff to save salary payment.
              </p>
            </div>

            <div className="flex justify-end gap-[10px] p-2 border-t">
              <button className="second-btn" onClick={closeModal13}>
                Okay
              </button>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={modalIsOpen14}
          onAfterOpen={afterOpenModal14}
          onRequestClose={closeModal14}
          // style={customStyles}
          contentLabel="Example Modal"
          className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
        >
          <h2
            ref={(_subtitle) => (subtitle = _subtitle)}
            className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-t-lg text-[14px]"
          >
            No Staff Selected
          </h2>
          <button
            onClick={closeModal14}
            className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
          >
            <CloseIcon className="text-white" />
          </button>
          <div className="p-[10px] pb-2">
            <div className="pt-[30px] pb-[30px] text-center">
              <WarningIcon className="text-red-600 transition warning-icon" />
              <p className="mt-3">Please select staff to pay salary online.</p>
            </div>

            <div className="flex justify-end gap-[10px] p-2 border-t">
              <button className="second-btn" onClick={closeModal14}>Okay</button>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default RunPayroll;
